// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-sign[data-v-08c42fb5] {\n  width: 100%;\n  height: 100%;\n  background-color: #ededed;\n}", ""]);
// Exports
module.exports = exports;
